import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_RET013_Request,
  IAPI_RET013_Response,
  IAPI_RET009_Request,
  IAPI_RET009_Response,
  IAPI_RET008_Request,
  IAPI_RET008_Response,
} from "../../../type/apiType";

// 退職手当金の請求手続き（請求者確認）表示
// API仕様書_退職者
const httpAPI_RET013 = async (
  param: IAPI_RET013_Request
): Promise<IAPI_RET013_Response> => {
  let res = await http.post(ApiUrl.API_RET013, {
    ...param,
  });
  return res.data;
};

// 退職手当金振込先金融機関変更届更新
// API仕様書_退職者
const httpAPI_RET009 = async (
  param: IAPI_RET009_Request
): Promise<IAPI_RET009_Response> => {
  let res = await http.post(ApiUrl.API_RET009, {
    ...param,
  });
  return res.data;
};

// 退職手当金振込先金融機関変更届参照
// API仕様書_退職者
const httpAPI_RET008 = async (
  param: IAPI_RET008_Request
): Promise<IAPI_RET008_Response> => {
  let res = await http.post(ApiUrl.API_RET008, {
    ...param,
  });
  return res.data;
};

export { httpAPI_RET013, httpAPI_RET009, httpAPI_RET008 };
